import { useFormikContext } from "formik";
import React from "react";
import { getName } from "../../../utils/functions";
import ErrorMessage from "../ErrorrMessage";
import textFieldStyles from "../TextField/TextField.module.css";
import styles from "./RatingScale.module.css";

const RatingScale = ({ field_label, displayLabel, field_items, parent, isRequired }) => {
  const { setFieldValue, values } = useFormikContext();
  const name = getName(parent, field_label);
  const currentValue = values[name];

  // If field_items is not provided or empty, default to 0-10 or 1-5
  const options = field_items || ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];

  // Helper to determine if we should show extreme labels
  const showLabels = options.length > 5;
  const leftLabel = "Not at all likely";
  const rightLabel = "Extremely Likely";

  return (
    <div className={styles.ratingScaleContainer}>
      <label className={textFieldStyles.label}>
        {displayLabel || field_label}
        {isRequired === "true" && <span style={{ color: '#d32f2f', paddingLeft: '4px' }}>*</span>}
      </label>
      
      {showLabels && (
        <div className={styles.extremeLabels}>
          <span>Where: 0 = {leftLabel}</span>
          <span>10 = {rightLabel}</span>
        </div>
      )}

      <div className={styles.scaleGrid}>
        {options.map((option, index) => {
          const isSelected = String(currentValue) === String(option);
          return (
            <div
              key={index}
              className={`${styles.scaleBox} ${isSelected ? styles.selected : ""}`}
              onClick={() => setFieldValue(name, option)}
            >
              {option}
            </div>
          );
        })}
      </div>
      
      <ErrorMessage name={name} />
    </div>
  );
};

export default RatingScale;
